/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { paragraphXSmall, weightMedium } from 'src/components/css'

interface Props {
  values: string[]
}

/**
 * Available days / times as outlined chips — the card's treatment, carried into
 * the grid so the same values look the same in both views.
 */
const ChipListCell = ({ values }: Props) => {
  if (!values.length) {
    return null
  }
  return (
    <span css={rowStyle}>
      {values.map((v) => (
        <span key={v} css={chipStyle}>
          {v}
        </span>
      ))}
    </span>
  )
}

export default ChipListCell

// Full cell height so the chips sit on the row's centre line rather than its
// text baseline — see TeamNameCell.
const rowStyle = css`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 4px;
  overflow: hidden;
`
const chipStyle = css`
  ${paragraphXSmall};
  ${weightMedium};
  color: ${colors.PRIMARY};
  border: 1px solid ${colors.PRIMARY};
  padding: 1px 8px;
  border-radius: 999px;
  white-space: nowrap;
`
